import ADAUSD from './icons/currency/ADAUSD.svg';
import AUDCAD from './icons/currency/AUDCAD.svg';
import AUDCHF from './icons/currency/AUDCHF.svg';
import AUDJPY from './icons/currency/AUDJPY.svg';
import AUDNZD from './icons/currency/AUDNZD.svg';
import AUDUSD from './icons/currency/AUDUSD.svg';
import AUS200 from './icons/currency/AUS200.svg';
import BTCUSD from './icons/currency/BTCUSD.svg';
import CADCHF from './icons/currency/CADCHF.svg';
import CADJPY from './icons/currency/CADJPY.svg';
import CHNIND from './icons/currency/CHNIND.svg';
import CHFJPY from './icons/currency/CHFJPY.svg';
import DOTUSD from './icons/currency/DOTUSD.svg';
import ETHUSD from './icons/currency/ETHUSD.svg';
import EU50 from './icons/currency/EU50.svg';
import EURAUD from './icons/currency/EURAUD.svg';
import EURCAD from './icons/currency/EURCAD.svg';
import EURCHF from './icons/currency/EURCHF.svg';
import EURGBP from './icons/currency/EURGBP.svg';
import EURJPY from './icons/currency/EURJPY.svg';
import EURNZD from './icons/currency/EURNZD.svg';
import EURUSD from './icons/currency/EURUSD.svg';
import FRA40 from './icons/currency/FRA40.svg';
import GBPAUD from './icons/currency/GBPAUD.svg';
import GBPCAD from './icons/currency/GBPCAD.svg';
import GBPCHF from './icons/currency/GBPCHF.svg';
import GBPJPY from './icons/currency/GBPJPY.svg';
import GBPNZD from './icons/currency/GBPNZD.svg';
import GBPUSD from './icons/currency/GBPUSD.svg';
import GER30 from './icons/currency/GER30.svg';
import HKIND from './icons/currency/HKIND.svg';
import ITA40 from './icons/currency/ITA40.svg';
import JAP225 from './icons/currency/JAP225.svg';
import LTCUSD from './icons/currency/LTCUSD.svg';
import NZDCAD from './icons/currency/NZDCAD.svg';
import NZDCHF from './icons/currency/NZDCHF.svg';
import NZDJPY from './icons/currency/NZDJPY.svg';
import NZDUSD from './icons/currency/NZDUSD.svg';
import SPA35 from './icons/currency/SPA35.svg';
import UK100 from './icons/currency/UK100.svg';
import US30 from './icons/currency/US30.svg';
import US100 from './icons/currency/US100.svg';
import US500 from './icons/currency/US500.svg';
import USDCAD from './icons/currency/USDCAD.svg';
import USDCHF from './icons/currency/USDCHF.svg';
import USDHKD from './icons/currency/USDHKD.svg';
import USDJPY from './icons/currency/USDJPY.svg';
import XAGUSD from './icons/currency/XAGUSD.svg';
import XAUUSD from './icons/currency/XAUUSD.svg';
import XLMUSD from './icons/currency/XLMUSD.svg';
import XPDUSD from './icons/currency/XPDUSD.svg';
import XPTUSD from './icons/currency/XPTUSD.svg';
import XRPUSD from './icons/currency/XRPUSD.svg';

export const DEFAULT_CURRENCY_ICONS = [
  { label: 'ADAUSD', src: ADAUSD },
  { label: 'AUDCAD', src: AUDCAD },
  { label: 'AUDCHF', src: AUDCHF },
  { label: 'AUDJPY', src: AUDJPY },
  { label: 'AUDNZD', src: AUDNZD },
  { label: 'AUDUSD', src: AUDUSD },
  { label: 'AUS200', src: AUS200 },
  { label: 'BTCUSD', src: BTCUSD },
  { label: 'CADCHF', src: CADCHF },
  { label: 'CADJPY', src: CADJPY },
  { label: 'CHNIND', src: CHNIND },
  { label: 'CHFJPY', src: CHFJPY },
  { label: 'DOTUSD', src: DOTUSD },
  { label: 'ETHUSD', src: ETHUSD },
  { label: 'EU50', src: EU50 },
  { label: 'EURAUD', src: EURAUD },
  { label: 'EURCAD', src: EURCAD },
  { label: 'EURCHF', src: EURCHF },
  { label: 'EURGBP', src: EURGBP },
  { label: 'EURJPY', src: EURJPY },
  { label: 'EURNZD', src: EURNZD },
  { label: 'EURUSD', src: EURUSD },
  { label: 'FRA40', src: FRA40 },
  { label: 'EU50', src: EU50 },
  { label: 'GBPAUD', src: GBPAUD },
  { label: 'GBPCAD', src: GBPCAD },
  { label: 'GBPCHF', src: GBPCHF },
  { label: 'GBPJPY', src: GBPJPY },
  { label: 'GBPNZD', src: GBPNZD },
  { label: 'GBPUSD', src: GBPUSD },
  { label: 'GER30', src: GER30 },
  { label: 'HKIND', src: HKIND },
  { label: 'ITA40', src: ITA40 },
  { label: 'JAP225', src: JAP225 },
  { label: 'LTCUSD', src: LTCUSD },
  { label: 'NZDCAD', src: NZDCAD },
  { label: 'NZDCHF', src: NZDCHF },
  { label: 'NZDJPY', src: NZDJPY },
  { label: 'NZDUSD', src: NZDUSD },
  { label: 'SPA35', src: SPA35 },
  { label: 'UK100', src: UK100 },
  { label: 'US30', src: US30 },
  { label: 'US100', src: US100 },
  { label: 'US500', src: US500 },
  { label: 'USDCAD', src: USDCAD },
  { label: 'USDCHF', src: USDCHF },
  { label: 'USDHKD', src: USDHKD },
  { label: 'USDJPY', src: USDJPY },
  { label: 'XAGUSD', src: XAGUSD },
  { label: 'XAUUSD', src: XAUUSD },
  { label: 'XLMUSD', src: XLMUSD },
  { label: 'XPDUSD', src: XPDUSD },
  { label: 'XPTUSD', src: XPTUSD },
  { label: 'XRPUSD', src: XRPUSD },
];
